
import base from './base';
import dev from './dev';
import qa from './qa';
import stg from './stg';
import perf from './perf';
import prod from './prod';

let env;

switch (window.location.hostname) {
    case 'local.insights.pearson.com':
    case 'gps-dev-insights.pearson.com':
    case 'everestui-dot-pearson-gps-dev-00.nw.r.appspot.com':
	case 'everest-everestui-dev.dataservices.pearsondev.tech':
        env = dev;
        break;

    case 'qa.everest-ui.pearson.com':
        env = qa;
        break;

    case 'gps-perf-insights.pearson.com':
	case 'everest-everestui-perf.dataservices.pearsondev.tech':
        env = perf;
        break;

    case 'everestui-dot-pearson-gps-stg.nw.r.appspot.com':
    case 'gps-stg-insights.pearson.com':
	case 'everest-everestui-stg.dataservices.pearsondev.tech':
        env = stg;
        break;

    case 'insights.pearson.com':
    case 'www.insights.pearson.com':
    case 'everestui-dot-pearson-gps-prd.nw.r.appspot.com':
    case 'everest-everestui-prd.dataservices.pearsonprd.tech':
        env = prod;
        break;

    default:
        env = prod;
}

export default { ...base, ...env };
